export type Review = {
  id: string;
  title: string;
  description: string;
  userName: string;
  createdAt?: Date;
  rate: number;
  replies: Reply[];
  totalLikes: number;
  userOpinion?: {
    id: string;
  };
  revision: string;
};

export type Reply = {
  id: string;
  description: string;
  userName: string;
};

export type Opinion = {
  id: string;
};

export enum AppType {
  WIX_APP = 'wix app',
  TPA = 'tpa',
}
